export enum Role {
  WORKSPACE_OWNER = "WORKSPACE_OWNER",
}
